<template>
  <section id="footer" class="section-foot" ref="footer">
        <footer class="app-footer">
          <div class="footer-content">
            <!-- 左侧：图片+文字 -->
            <div class="footer-section left-section">
              <div class="image-container">
                <img
                  src="@/assets/logo-w-cn.svg"
                  alt="左侧图片"
                  class="footer-image"
                />
                
              </div>
              <p class="footer-text-img">环保 节能 爱地球</p>
              
               <p class="footer-text">工业自动化</p>
                <p class="footer-text">@2025 Delta Electtonics, Inc. ALL Rights Reserved</p>
            </div>

            <!-- 中间第一部分：隐私条约 -->
            <div class="footer-section middle-section">
              <h4 class="section-title-foot">信息</h4>
              <ul class="link-list">
                <li><a href="http://www.delta-china.com.cn/zh-CN/information/Privacy-Policy" class="footer-link">隐私权政策</a></li>
                <li><a href="http://www.delta-china.com.cn/zh-CN/information/Terms-of-use" class="footer-link">使用条款</a></li>
                <li><a href="http://www.delta-china.com.cn/zh-CN/information/Data-Collection" class="footer-link">资料搜集</a></li>
               
              </ul>
            </div>

            <!-- 中间第二部分：支持与帮助 -->
            <div class="footer-section middle-section">
              <h4 class="section-title-foot">关注我们</h4>
              <ul class="link-list">
                <li><a href="https://www.delta-china.com.cn/zh-CN/solutions/Industrial-Automation-Solutions/ALL/" class="footer-link">解锁更多行业解决方案</a></li>  
                <!-- 添加空白行 -->
                <li class="spacer">&nbsp;</li>
                <li class="spacer">&nbsp;</li>
              </ul>
            </div>

            <!-- 右侧：图片 -->
            <div class="footer-section right-section">
              <div class="image-container">
                <img
                  src="@/assets/foot.jpg"
                  alt="右侧图片"
                  class="footer-image-right"
                />
              </div>
            </div>
          </div>
        </footer>
      </section>
</template>
<script>
export default {
  data() {
    return {};
  },
 
  methods: {},
  created() {}
};
</script>

<style scoped>
.section-foot {
  height: 180px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #ebeef5;
  background-color: #6d6e71;
}


.app-footer {
  background-color: #6d6e71; /* 深灰色背景 */
  color: #ffffff;
  padding: 0px 0;
  width: 100%;
  overflow: hidden; /* 防止内容溢出 */
}

.footer-content {
  display: flex;
  flex-wrap: nowrap; /* 关键：禁止换行 */
  justify-content: space-between; /* 平均分布空间 */
  /*align-items: flex-start;  顶部对齐 */
  max-width: 1200px; /* 最大宽度限制 */
  margin: 0 auto;
  padding: 0 10px;
  box-sizing: border-box;
}

.footer-section {
  flex: 1; /* 每个部分平均分配空间 */
  min-width: 0; /* 关键：允许内容收缩 */
  padding: 0 15px;
  box-sizing: border-box;
}

/* 左侧区域样式 */
.left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;/*center */
  text-align: left;/*center */
  flex: 2; /* 与其他部分同等比例 */
}

/* 中间区域样式 */
.middle-section {
  text-align: left;/*center */
  flex: 1; /* 与其他部分同等比例 */
  background-color: #dcdcdc49; /* 统一的浅灰色背景 */   
  margin: 20px 10px 40px; /* 左右外边距 */
}



.section-title-foot {
  font-size: clamp(14px, 1.5vw, 18px); /* 响应式字体大小 */
  font-weight: 600;
  margin-bottom: 10px;
  color: #ecf0f1;
}

/* .section-title-foot::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #3498db;
} */

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  margin-bottom: 2px;
}
.spacer{
  margin-bottom: 2px;
}

.footer-link {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s;
  font-size: clamp(12px, 1.2vw, 14px); /* 响应式字体大小 */
  white-space: nowrap; /* 防止链接文字换行 */
}

.footer-link:hover {
  color: #3498db;
}

/* 图片容器样式 */
.image-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}

.footer-image {
  object-fit: contain; /* 保持图片比例 */
  border-radius: 4px;
  width: 150px;
  height: 90px;
  margin-top: -20px;
}

.footer-image-right {
  margin-top: 20px;
  border-radius: 4px;
  width: 120px;
  height: 120px;
}

/* 左侧图片下方的文字样式 */
.footer-text {
  font-size: clamp(14px, 1.2vw, 14px); /* 响应式字体大小 */
  line-height: 0.6;
  color: #bdc3c7;
  margin-top: 5px;
  white-space: nowrap; /* 防止文字换行 */
}

.footer-text-img {
  font-size: clamp(13px, 1.2vw, 14px); /* 响应式字体大小 */
  line-height: 0.6;
  color: #bdc3c7;
  margin-top: -8px;
 
  white-space: nowrap; /* 防止文字换行 */
}

/* 响应式设计：超小屏幕调整 */
@media (max-width: 768px) {
  .footer-content {
    padding: 0 10px; /* 减少内边距 */
  }

  .footer-section {
    padding: 0 8px; /* 减少内边距 */
  }

  .footer-image {
    max-height: 60px; /* 进一步缩小图片 */
  }
}

/* 极小屏幕保护（防止内容过度挤压） */
@media (max-width: 480px) {
  .footer-section {
    flex: 1 1 auto; /* 允许轻微收缩 */
    min-width: 80px; /* 设置最小宽度防止过度挤压 */
  }

  .link-list li {
    margin-bottom: 5px; /* 减少间距 */
  }
}
</style>